import { render } from "./PriceFacet.vue?vue&type=template&id=7548a84d"
import script from "./PriceFacet.vue?vue&type=script&lang=js"
export * from "./PriceFacet.vue?vue&type=script&lang=js"

import exportComponent from "/opt/vr23-npm/htdocs/templates/vr23/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__